import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon, PhoneIcon } from 'lucide-react';
import { pendingSources } from '../data/pendingSources';
export function PendingSourcesPanel() {
  const [open, setOpen] = useState(false);
  return <section className="w-full max-w-3xl" aria-label="Sources needing manual entry" data-id="element-102" data-mp="1a8lmec8bzr33">
      <button type="button" onClick={() => setOpen(value => !value)} aria-expanded={open} className="flex w-full items-center justify-between gap-4 rounded-xl border border-line bg-surface px-5 py-3 text-left transition-colors duration-150 hover:border-ink-soft" data-id="element-103" data-mp="1f3hj3poij2mj">
        <span data-id="element-104" data-mp="rdn698471e2a">
          <span className="text-sm font-medium text-ink" data-id="element-105" data-mp="weuch2qou56u">
            {pendingSources.length} sellers in range publish no prices
          </span>
          <span className="mt-0.5 block text-sm text-ink-muted" data-id="element-106" data-mp="igcsng3wlcu7">
            Call these, then use “Add a price manually” on any result.
          </span>
        </span>
        <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ink-soft transition-transform duration-200 ${open ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-107" data-mp="2d95ngi481ta" />
      </button>

      {open && <motion.ul initial={{
      opacity: 0,
      y: -4
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} className="mt-2 divide-y divide-line overflow-hidden rounded-xl border border-line bg-surface" data-id="element-108" data-mp="cadob6cr5f5c">
          {pendingSources.map(source => <li key={source.id} className="px-5 py-3" data-id="element-109" data-mp="3arhohwuu5e89">
              <div className="flex flex-wrap items-baseline justify-between gap-x-4 gap-y-1" data-id="element-110" data-mp="3pja1w3b2ki7c">
                <p className="text-sm font-medium text-ink" data-id="element-111" data-mp="3kqgzhm32plyf">{source.name}</p>
                {source.phone ? <a href={`tel:${source.phone.replace(/[^\d]/g, '')}`} className="tnum inline-flex shrink-0 items-center gap-1 text-sm text-ink-muted transition-colors duration-150 hover:text-accent" data-id="element-112" data-mp="2x0mm93eudvdn">
                    <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-113" data-mp="3ls2233ru51fp" />
                    {source.phone}
                  </a> : <span className="shrink-0 text-sm text-ink-soft" data-id="element-114" data-mp="3qk26p9iuoiim">number not on file</span>}
              </div>
              <p className="mt-0.5 text-sm text-ink-muted" data-id="element-115" data-mp="2ys48nbm28azw">
                {source.city} — {source.reason}
              </p>
            </li>)}
        </motion.ul>}
    </section>;
}